import { render, staticRenderFns } from "./ProviderForgotPassword.vue?vue&type=template&id=587a3b85&scoped=true"
import script from "./ProviderForgotPassword.vue?vue&type=script&lang=js"
export * from "./ProviderForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ProviderForgotPassword.vue?vue&type=style&index=0&id=587a3b85&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a3b85",
  null
  
)

export default component.exports